/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {tableAPIMethod, getRoute} from '../../utils/tableAPIMethod';

const businessDetailsAPI = async (
  type: APIType,
  data: any = undefined,
  id: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const response = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.businessDetails}/${getRoute(
        type,
        id
      )}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });

    if (type === APITypeEnum.GET_ALL) {
      return response.data.data;
    } else {
      return response.data;
    }
  } catch (err) {
    console.log('err:', err);
  }
};

export default businessDetailsAPI;
